import { compareVersion, getClientVersion, getUserAgent } from '@/utils/compareVersion.js';
import { getApp } from '@/utils/util.js';
import { isBrowser } from '@/utils/env.js';

const version = new Proxy({}, {
  get(target, propKey, receiver) {
    const value = Reflect.get(target, propKey, receiver);
    if (typeof value !== 'undefined' || typeof propKey !== 'string') return value;

    if (propKey === 'current') {
      const ua = isBrowser() ? window.navigator.userAgent : getApp()?.$options?.$superProps?.httpHeaderInfo?.['User-Agent'];
      if (ua) {
        const version = getClientVersion(ua);
        Reflect.set(target, propKey, version, receiver);
        return version;
      }
      getUserAgent().then((ua) => {
        const version = getClientVersion(ua);
        Reflect.set(target, propKey, version, receiver);
      });
      return Reflect.get(target, propKey, receiver);
    }

    if (!/^(after|before|between)_((\d+_)+)(_((\d+_)+))?$/i.test(`${propKey}_`)) {
      return Reflect.get(target, propKey, receiver);
    }

    let currentVersion;
    const commandName = RegExp.$1;
    let targetVersion1 = RegExp.$2 || '';
    let targetVersion2 = RegExp.$5 || '';
    targetVersion1 = targetVersion1.replace(/_$/, '').replace(/_/g, '.');
    targetVersion2 = targetVersion2.replace(/_$/, '').replace(/_/g, '.');
    if (commandName && targetVersion1) {
      currentVersion = Reflect.get(target, 'current', receiver);
    }
    if (currentVersion) {
      let result;
      if (commandName === 'between') {
        result = compareVersion(targetVersion1, currentVersion) >= 0
          && compareVersion(targetVersion2, currentVersion) < 0;
      }
      if (commandName === 'before') {
        result = compareVersion(targetVersion1, currentVersion) < 0;
      }
      if (commandName === 'after') {
        result = compareVersion(targetVersion1, currentVersion) >= 0;
      }
      if (typeof result !== 'undefined') {
        Reflect.set(target, propKey, result, receiver);
        return result;
      }
    }
    return Reflect.get(target, propKey, receiver);
  },
});

export default {
  version,
};
